import React, { useState } from "react";
import UseGetAllDoc from "../Hooks/UseGetAllDoc";
import PipelineCard from "./PipelineCard";
import { useEffect } from "react";
import { getAllDocsSnap, setDocData } from "../Firebase/Firebase.utils";
import { AnimatePresence, motion } from "framer-motion";
import PageModal from "../components/PageModal";
import SummaryReport from "./SummaryReport";
import { useNavigate } from "react-router-dom";
import InputBoxSelect from "../components/InputBoxSelect";
import InputBox from "../components/InputBox";
import {
  FiFilter,
  FiSearch,
  FiMaximize2,
  FiMinimize2,
  FiPieChart,
  FiCheckCircle,
  FiXCircle,
  FiChevronRight,
  FiUser,
  FiBriefcase,
  FiUsers,
  FiMapPin,
  FiCalendar,
  FiSquare,
  FiDollarSign,
  FiPercent,
  FiHome,
  FiList,
  FiGrid,
} from "react-icons/fi";

export default function CLPipeline({ fullScreen }) {
  const statusPercentages = ["10%", "30%", "50%", "90%", "100%"];
  const navigate = useNavigate();
  const filters = ["active", "inactive"];
  const [accounts, setAccounts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState("active");
  const [percentageArrays, setPercentageArrays] = useState(statusPercentages);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewMode, setViewMode] = useState(false);
  const [landlordRep, setLandlordRep] = useState([]);
  const [tenantRep, setTenantRep] = useState([]);
  const [fullScreenMode, setFullScreenMode] = useState(fullScreen || false);
  const [agents, setAgents] = useState([]);
  const [agent, setAgent] = useState(null);
  const [viewType, setViewType] = useState("card"); // 'card' or 'list'

  // Format currency function
  const formatCurrency = (value) => {
    if (!value) return null;

    // Remove any existing commas and the peso sign if present
    const cleanValue = value.toString().replace(/[₱,]/g, "");

    // Check if it's a valid number
    if (isNaN(parseFloat(cleanValue))) return value;

    // Format with commas and 2 decimal places
    return new Intl.NumberFormat("en-PH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(parseFloat(cleanValue));
  };

  useEffect(() => {
    const fetchAgents = async () => {
      await getAllDocsSnap("users", (data) => {
        console.log(data);
        const filteredUsers = data.filter(
          (user) =>
            user.department === "Commercial Leasing" &&
            user.roles.includes("agent")
        );

        //sort alphabetically
        filteredUsers.sort((a, b) => {
          if (a.email < b.email) {
            return -1;
          }
          if (a.email > b.email) {
            return 1;
          }
          return 0;
        });

        setAgents(filteredUsers);
        console.log(filteredUsers);
      });
    };
    fetchAgents();
  }, []);

  useEffect(() => {
    const fetchLandlordRep = async () => {
      await getAllDocsSnap("landlordRepRequirements", (data) => {
        const mappedData = data.map((item) => {
          return {
            accountType: "Landlord Rep",
            ...item,
          };
        });
        setLandlordRep(mappedData);
      });
    };
    fetchLandlordRep();
  }, []);

  useEffect(() => {
    const fetchAccounts = async () => {
      await getAllDocsSnap("tenantRep", (data) => {
        const mappedData = data.map((item) => {
          return {
            accountType: "Tenant Rep",
            ...item,
          };
        });
        setTenantRep(mappedData);
        setIsLoading(false);
      });
    };
    fetchAccounts();
  }, []);

  //concatenate landlordRep and tenantRep
  const allAccounts = [...landlordRep, ...tenantRep];

  console.log(allAccounts);

  const [activePercentage, setActivePercentage] = React.useState("All");

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-white">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#002368]"></div>
      </div>
    );
  }

  //arrange accounts alphabetically using tenantName
  allAccounts.sort((a, b) => {
    if (a.tenantName < b.tenantName) {
      return -1;
    }
    if (a.tenantName > b.tenantName) {
      return 1;
    }
    return 0;
  });

  const currentList = allAccounts.filter(
    (account) => account.status === activeFilter
  );

  const filteredAccounts = currentList.filter(
    (account) =>
      percentageArrays.includes(account.pipeline_status) &&
      account.tenantName.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (agent ? account.team_lead === agent : true)
  );

  console.log(filteredAccounts.length);

  const setActiveFiltersInArray = (selected) => {
    if (percentageArrays.includes(selected)) {
      setPercentageArrays(percentageArrays.filter((item) => item !== selected));
    } else {
      setPercentageArrays([...percentageArrays, selected]); // Spread operator to create a new array with selected
    }
  };

  const handleSelectAll = () => {
    if (statusPercentages.every((item) => percentageArrays.includes(item))) {
      setPercentageArrays([]);
      return;
    }
    setPercentageArrays(statusPercentages);
  };

  const handleViewReport = () => {
    setViewMode(!viewMode);
  };

  const handleNavigate = (type, id) => {
    if (type === "Landlord Rep") {
      navigate(
        `/leasing/landlordrepresentation/${id}?link=Requirement+Details`
      );
    } else {
      navigate(`/leasing/tenantRep/req/${id}?link=Requirement+Details`);
    }
  };

  const toggleActiveStatus = async (type, id) => {
    const account = allAccounts.find((account) => account.id === id);
    const status = account.status === "active" ? "inactive" : "active";
    await setDocData(
      type === "Landlord Rep" ? "landlordRepRequirements" : "tenantRep",
      id,
      { status }
    );
  };

  const handleFullScreen = () => {
    setFullScreenMode(!fullScreenMode);
  };

  const agentOptions = agents.map((agent) => {
    return {
      value: agent.email,
      label: agent.email
        .replace("@leechiu.com", "")
        .replace(".", " ")
        .toUpperCase(),
    };
  });

  const newAgentOptions = [
    {
      value: null,
      label: "All Agents",
    },
    ...agentOptions,
  ];

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
        <h1 className="text-2xl font-bold text-[#002368] mb-4 md:mb-0">
          Commercial Leasing Pipeline
        </h1>
        <div className="flex gap-2">
          <button
            className="flex items-center gap-2 bg-[#002368] hover:bg-[#001a4d] text-white py-2 px-4 rounded-md transition-all"
            onClick={handleViewReport}
          >
            <FiPieChart size={18} />
            <span>Summary Report</span>
          </button>

          {!fullScreenMode && !fullScreen && (
            <button
              className="flex items-center gap-2 border border-[#002368] text-[#002368] hover:bg-gray-50 py-2 px-4 rounded-md transition-all"
              onClick={handleFullScreen}
            >
              <FiMaximize2 size={18} />
              <span className="hidden sm:inline">Full Screen</span>
            </button>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="relative">
          <InputBoxSelect
            options={newAgentOptions}
            value={newAgentOptions.filter((option) => option.value === agent)}
            onChange={(e) => setAgent(e.value)}
            defaultValue="Select Agent"
          />
        </div>

        <div className="relative">
          <InputBox
            name="search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search clients..."
            className="pl-10 w-full py-2 border border-gray-300 rounded-md shadow-sm"
          />
        </div>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div className="flex items-center gap-2">
          <FiFilter size={18} className="text-[#002368]" />
          <div className="text-sm font-medium text-gray-700">Status:</div>
          <div className="flex bg-gray-100 rounded-lg overflow-hidden">
            {filters.map((filter, index) => (
              <button
                key={index}
                className={`capitalize px-4 py-2 text-sm font-medium transition-all ${
                  activeFilter === filter
                    ? "bg-[#002368] text-white"
                    : "text-gray-700 hover:bg-gray-200"
                }`}
                onClick={() => setActiveFilter(filter)}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-2 overflow-x-auto pb-2">
          <div className="text-sm font-medium text-gray-700 whitespace-nowrap">
            Progress:
          </div>
          <button
            className={`px-3 py-1 text-xs rounded-full transition-all whitespace-nowrap ${
              statusPercentages.every((item) => percentageArrays.includes(item))
                ? "bg-[#002368] text-white"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
            onClick={handleSelectAll}
          >
            All
          </button>
          {statusPercentages.map((status, index) => (
            <button
              key={index}
              className={`px-3 py-1 text-xs rounded-full transition-all whitespace-nowrap ${
                percentageArrays.includes(status)
                  ? "bg-[#ff5003] text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
              onClick={() => setActiveFiltersInArray(status)}
            >
              {status}
            </button>
          ))}
        </div>
      </div>

      <div className="flex justify-between items-center mb-4">
        <div className="text-sm font-medium text-gray-700">
          Total Accounts:{" "}
          <span className="text-[#002368] font-bold">
            {filteredAccounts.length}
          </span>
        </div>

        <div className="flex items-center bg-gray-100 rounded-lg overflow-hidden">
          <button
            onClick={() => setViewType("card")}
            className={`p-2 transition-all ${
              viewType === "card"
                ? "bg-[#002368] text-white"
                : "text-gray-700 hover:bg-gray-200"
            }`}
            title="Card View"
          >
            <FiGrid size={18} />
          </button>
          <button
            onClick={() => setViewType("list")}
            className={`p-2 transition-all ${
              viewType === "list"
                ? "bg-[#002368] text-white"
                : "text-gray-700 hover:bg-gray-200"
            }`}
            title="List View"
          >
            <FiList size={18} />
          </button>
        </div>
      </div>

      {viewType === "card" ? (
        <div className="space-y-4">
          {filteredAccounts.map((account, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
              className="bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-all overflow-hidden"
            >
              <div className="p-4 relative">
                <div className="absolute top-4 right-4 flex items-center gap-2">
                  <span
                    className={`flex items-center gap-1 text-xs font-medium py-1 px-2 rounded-full ${
                      account.status === "active"
                        ? "bg-green-100 text-green-700"
                        : "bg-gray-100 text-gray-700"
                    }`}
                  >
                    {account.status === "active" ? (
                      <FiCheckCircle size={14} />
                    ) : (
                      <FiXCircle size={14} />
                    )}
                    <span className="capitalize">{account.status}</span>
                  </span>
                  <button
                    onClick={() =>
                      toggleActiveStatus(account.accountType, account.id)
                    }
                    className="text-gray-400 hover:text-gray-600"
                  >
                    {account.status === "active" ? (
                      <FiXCircle size={16} />
                    ) : (
                      <FiCheckCircle size={16} />
                    )}
                  </button>
                </div>

                <div className="flex items-center gap-2 mb-4">
                  <span
                    className={`text-xs font-bold text-white px-2 py-1 rounded-md ${
                      account.accountType === "Landlord Rep"
                        ? "bg-[#002368]"
                        : "bg-[#ff5003]"
                    }`}
                  >
                    {account.accountType === "Landlord Rep" ? "LR" : "TR"}
                  </span>
                  <h2 className="text-lg font-bold text-[#002368]">
                    {account.tenantName}
                  </h2>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-8 gap-y-4 mb-4">
                  <div className="flex items-start gap-2">
                    <FiBriefcase className="text-[#002368] mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-xs text-gray-500">Industry</p>
                      <p className="text-sm font-medium">
                        {account.tenantIndustry || "Not Indicated"}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-2">
                    <FiUser className="text-[#002368] mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-xs text-gray-500">Lead</p>
                      <p className="text-sm font-medium capitalize">
                        {account.team_lead
                          ? account?.team_lead
                              .replace("@leechiu.com", "")
                              .replace(".", " ")
                          : "Not Indicated"}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-2">
                    <FiUsers className="text-[#002368] mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-xs text-gray-500">Source</p>
                      <p className="text-sm font-medium">
                        {account.leadSource || "Not Indicated"}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-2">
                    <FiBriefcase className="text-[#002368] mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-xs text-gray-500">Type</p>
                      <p className="text-sm font-medium">
                        {account.requirementType || "Not Indicated"}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-2">
                    <FiHome className="text-[#002368] mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-xs text-gray-500">Building</p>
                      <p className="text-sm font-medium">
                        {account.buildingName || "Not Indicated"}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-2">
                    <FiMapPin className="text-[#002368] mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-xs text-gray-500">Location</p>
                      <p className="text-sm font-medium">
                        {account.requirementLocation || "Not Indicated"}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-2">
                    <FiCalendar className="text-[#002368] mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-xs text-gray-500">
                        Forecast Billing Date
                      </p>
                      <p className="text-sm font-medium">
                        {account.billingDate || "Not Indicated"}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-2">
                    <FiSquare className="text-[#002368] mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-xs text-gray-500">Size</p>
                      <p className="text-sm font-medium">
                        {account.requirementSize || "Not Indicated"} sqm
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-2">
                    <FiDollarSign className="text-[#002368] mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-xs text-gray-500">Budget</p>
                      <p className="text-sm font-medium">
                        {account.requirementBudget
                          ? `₱${formatCurrency(account.requirementBudget)}`
                          : "Not Indicated"}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-2">
                    <FiDollarSign className="text-[#002368] mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-xs text-gray-500">Fee</p>
                      <p className="text-sm font-medium">
                        {account.potentialFee
                          ? `₱${formatCurrency(account.potentialFee)}`
                          : "Please indicate in details"}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-2">
                    <FiPercent className="text-[#002368] mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-xs text-gray-500">Status %</p>
                      <p className="text-sm font-medium">
                        {account.pipeline_status ||
                          "Please indicate in details"}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mt-4 flex justify-end">
                  <button
                    onClick={() =>
                      handleNavigate(account.accountType, account.id)
                    }
                    className="flex items-center gap-1 text-[#ff5003] hover:text-[#cc4003] font-medium text-sm transition-colors"
                  >
                    See Details
                    <FiChevronRight size={16} />
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Client
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Lead
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Type
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Building
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Size
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Budget
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Fee
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Status
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredAccounts.map((account, index) => (
                <motion.tr
                  key={index}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.2, delay: index * 0.03 }}
                  className="hover:bg-gray-50"
                >
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <span
                        className={`flex-shrink-0 h-6 w-6 flex items-center justify-center rounded-md text-xs font-medium text-white ${
                          account.accountType === "Landlord Rep"
                            ? "bg-[#002368]"
                            : "bg-[#ff5003]"
                        }`}
                      >
                        {account.accountType === "Landlord Rep" ? "LR" : "TR"}
                      </span>
                      <div className="ml-2">
                        <div className="text-sm font-medium text-[#002368]">
                          {account.tenantName}
                        </div>
                        <div className="text-xs text-gray-500">
                          {account.tenantIndustry}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm capitalize">
                      {account.team_lead
                        ? account?.team_lead
                            .replace("@leechiu.com", "")
                            .replace(".", " ")
                        : "Not Indicated"}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    {account.requirementType || "Not Indicated"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    {account.buildingName || "Not Indicated"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    {account.requirementSize || "Not Indicated"} sqm
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    {account.requirementBudget
                      ? `₱${formatCurrency(account.requirementBudget)}`
                      : "Not Indicated"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    {account.potentialFee
                      ? `₱${formatCurrency(account.potentialFee)}`
                      : "Not Indicated"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <span
                        className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                          account.status === "active"
                            ? "bg-green-100 text-green-800"
                            : "bg-gray-100 text-gray-800"
                        }`}
                      >
                        {account.pipeline_status || "N/A"}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex items-center space-x-2">
                      <button
                        onClick={() =>
                          toggleActiveStatus(account.accountType, account.id)
                        }
                        className={`p-1 rounded-full ${
                          account.status === "active"
                            ? "text-green-600 hover:bg-green-100"
                            : "text-gray-400 hover:bg-gray-100"
                        }`}
                      >
                        {account.status === "active" ? (
                          <FiCheckCircle size={16} />
                        ) : (
                          <FiXCircle size={16} />
                        )}
                      </button>
                      <button
                        onClick={() =>
                          handleNavigate(account.accountType, account.id)
                        }
                        className="text-[#ff5003] hover:text-[#cc4003]"
                      >
                        <FiChevronRight size={16} />
                      </button>
                    </div>
                  </td>
                </motion.tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {viewMode && (
        <PageModal>
          <SummaryReport setViewMode={setViewMode} data={allAccounts} />
        </PageModal>
      )}

      {fullScreenMode && !fullScreen && (
        <PageModal>
          <div className="bg-white rounded-lg w-full p-6 min-h-screen">
            <div className="flex justify-end mb-4">
              <button
                className="flex items-center gap-2 text-[#002368] hover:text-[#001a4d]"
                onClick={() => setFullScreenMode(false)}
              >
                <FiMinimize2 size={18} />
                <span>Exit Full Screen</span>
              </button>
            </div>
            <CLPipeline fullScreen={fullScreenMode} />
          </div>
        </PageModal>
      )}
    </div>
  );
}
